import ApiHandler from "./ApiHandler";

const OAuthScope = {
  getAvailable: async (query) => await ApiHandler.i.auth().get(`/oauth/scope/available?${query.toString()}`),
};

export default OAuthScope;